"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
/**
 * Returns if the Txp options page is in dirty state (user made changes to it)
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(function isTxpOptionDirty(state) {
    var savedOptions = owa_calendar_configuration_1.getCalendarConfiguration();
    var formOptions = state.optionState;
    if (!savedOptions) {
        return false;
    }
    var EventsFromEmailEnabled = owa_options_core_1.getFallbackValueIfNull(formOptions.EventsFromEmailEnabled, savedOptions.EventsFromEmailEnabled);
    if (savedOptions.EventsFromEmailEnabled !== EventsFromEmailEnabled) {
        return true;
    }
    if (!EventsFromEmailEnabled) {
        // if savedOptions.EventsFromEmailEnabled == EventsFromEmailEnabled == false,
        // return not dirty since we don't have to check rest of the flags
        return false;
    }
    var CreateEventsFromEmailAsPrivate = owa_options_core_1.getFallbackValueIfNull(formOptions.CreateEventsFromEmailAsPrivate, savedOptions.CreateEventsFromEmailAsPrivate);
    if (CreateEventsFromEmailAsPrivate !== savedOptions.CreateEventsFromEmailAsPrivate) {
        return true;
    }
    var isEventFlagDirty = false;
    // Validate if the event flags are changed
    Object.keys(formOptions.Events).map(function (eventType) {
        var eventEnabled = owa_options_core_1.getFallbackValueIfNull(formOptions.Events[eventType], savedOptions[eventType]);
        if (eventEnabled !== savedOptions[eventType]) {
            isEventFlagDirty = true;
        }
    });
    return isEventFlagDirty;
});
//# sourceMappingURL=isTxpOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/utils/isTxpOptionDirty.js
// module id = 5272
// module chunks = 2